const events = {
  'widget.embed.loaded': 240,
  'widget.embed.vid.goToSite.click': 135,
  'widget.embed.vid.play.clicked': 242,
  'widget.embed.vid.start.play': 243,
  'widget.vid.buy.clicked': 220,
  'widget.vid.share.clicked': 225,
  'widget.embed.opened': 241,
  'widget.vid.error': 229,
  'widget.vid.info.clicked': 223,
  'widget.vid.fullScreen.entered': 234,
  'player.debug.info': 233,
  'player.play.done': 246,
  'player.play.requested': 245,
  'widget.video.autoplay.start': 280,
  'widget.poll.request.sent': 282,
  'widget.embed.vid.played': 272,
  playerVideoSettingsMenuClick: 826,
  playerVideoSettingsMenuOpen: 825,
  playerVideoSettingsChange: 827,
};

export default events;
